module.exports = __webpack_public_path__ + "static/img/laba02.a492ff83.gif";